import { useState } from "react";
import ToastBox from "../components/toastbox";

let toastId = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "info", position = "top", replace = false, duration = 3000) => {
    if (replace) {
      // Replace the last toast of the same type + position
      setToasts((prev) => {
        const updated = [...prev];
        const idx = updated.findIndex((t) => t.type === type && t.position === position);
        if (idx !== -1) {
          updated[idx] = { ...updated[idx], message };
          return updated;
        }
        // If none exists yet, create one (no auto-remove here!)
        return [...prev, { id: ++toastId, message, type, position, persistent: true }];
      });
      return;
    }

    const id = ++toastId;
    setToasts((prev) => [...prev, { id, message, type, position }]);

    // Auto remove only if NOT persistent
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  };

  const ToastContainer = () => {
    // Group toasts by position
    const grouped = toasts.reduce((acc, toast) => {
      acc[toast.position] = acc[toast.position] || [];
      acc[toast.position].push(toast);
      return acc;
    }, {});

    return (
      <>
        {Object.entries(grouped).map(([position, list]) => {
          const positions = {
            top: "top-6 left-1/2 transform -translate-x-1/2 flex flex-col gap-2",
            center:
              "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col gap-2",
            "bottom-right": "bottom-6 right-6 flex flex-col gap-2 items-end",
          };

          return (
            <div
              key={position}
              className={`fixed z-50 ${positions[position]}`}
            >
              {list.map((toast) => (
                <ToastBox
                  key={toast.id}
                  message={toast.message}
                  type={toast.type}
                  onClose={() =>
                    setToasts((prev) => prev.filter((t) => t.id !== toast.id))
                  }
                />
              ))}
            </div>
          );
        })}
      </>
    );
  };

  return { showToast, ToastContainer };
}
